module.exports = __webpack_public_path__ + "img/RedCard.e06cc17f.png";